var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1138_14235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.545 0C11.9425 0 11.4541 0.488438 11.4541 1.09092V5.45456C11.4541 6.05705 11.9425 6.54548 12.545 6.54548C13.1475 6.54548 13.6359 6.05705 13.6359 5.45456V1.09092C13.6359 0.488438 13.1475 0 12.545 0Z",
    fill: "#2D50A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.546 17.4551C11.9435 17.4551 11.4551 17.9435 11.4551 18.546V22.9096C11.4551 23.5121 11.9435 24.0006 12.546 24.0006C13.1485 24.0006 13.6369 23.5121 13.6369 22.9096V18.546C13.6369 17.9435 13.1485 17.4551 12.546 17.4551Z",
    fill: "#73A1FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.68811 6.60053L5.60252 3.51485C5.17661 3.0888 4.48586 3.0888 4.05977 3.51485C3.63372 3.94089 3.63372 4.6316 4.05977 5.0576L7.14536 8.14328C7.35836 8.35629 7.6376 8.46283 7.91669 8.46283C8.19583 8.46283 8.47511 8.35629 8.68802 8.14328C9.11416 7.71724 9.11416 7.02658 8.68811 6.60053Z",
    fill: "#355EC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3635 10.9092H20.1817C19.5793 10.9092 19.0908 11.3976 19.0908 12.0001C19.0908 12.6026 19.5793 13.091 20.1817 13.091H22.3635C22.966 13.091 23.4545 12.6026 23.4545 12.0001C23.4545 11.3976 22.966 10.9092 22.3635 10.9092Z",
    fill: "#C4D9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9453 15.8576C17.5193 15.4315 16.8286 15.4316 16.4025 15.8576C15.9765 16.2836 15.9766 16.9743 16.4025 17.4003L19.4882 20.4859C19.7012 20.6989 19.9804 20.8054 20.2596 20.8054C20.5388 20.8054 20.818 20.6988 21.0309 20.4859C21.457 20.0598 21.457 19.3691 21.0309 18.9431L17.9453 15.8576Z",
    fill: "#C4D9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.09138 12.0001C7.09138 11.3976 6.60295 10.9092 6.00046 10.9092H1.63682C1.03434 10.9092 0.545898 11.3976 0.545898 12.0001C0.545898 12.6026 1.03434 13.091 1.63682 13.091H6.00046C6.60295 13.091 7.09138 12.6026 7.09138 12.0001Z",
    fill: "#3D6DEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.68807 15.8566C8.26211 15.4306 7.57132 15.4306 7.14532 15.8566L4.05977 18.9422C3.63372 19.3681 3.63372 20.0589 4.05977 20.4849C4.27277 20.6979 4.552 20.8044 4.83119 20.8044C5.11038 20.8044 5.38961 20.698 5.60252 20.4849L8.68807 17.3994C9.11411 16.9734 9.11411 16.2827 8.68807 15.8566Z",
    fill: "#5286FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1138_14235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.419b9c01fa41602af970ed0475c5744a.svg";
export { ForwardRef as ReactComponent };